import { render, staticRenderFns } from "./ElementosAduanaCompra.vue?vue&type=template&id=246275ba&scoped=true&"
import script from "./ElementosAduanaCompra.vue?vue&type=script&lang=js&"
export * from "./ElementosAduanaCompra.vue?vue&type=script&lang=js&"
import style0 from "./ElementosAduanaCompra.vue?vue&type=style&index=0&id=246275ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246275ba",
  null
  
)

export default component.exports